import React, { useEffect, useState } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";

function index({ show, toggle }) {
    const [modal, setModal] = useState(undefined);

    useEffect(() => {
        const myModal = new bootstrap.Modal(
            document.getElementById("staticBackdrop")
        );
        setModal(myModal);
        myModal.show();
    }, []);
    useEffect(() => {
        if (modal) {
            if (show) {
                modal.show();
            } else {
                modal.hide();
            }
        }
    }, [show]);
    function handleClick(e) {
        e.preventDefault();
        toggle();
    }
    return (
        <div
            className="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header bg-info">
                        <h5 className="modal-title">
                            Comment utiliser ce générateur ?
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={handleClick}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <p>
                            Ce générateur permet de construire des cartes pour
                            les "Murs Sonores interactifs" proposés par{" "}
                            <a
                                href="https://www.easytis.com/fr/tts/3140-mur-sonore-interactif.html"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                EASITYS
                            </a>
                            .
                        </p>
                        <ol>
                            <li>
                                <p>
                                    Sur une carte, vous pouvez choisir
                                    d'afficher ou non du texte (case à cocher).
                                    Si vous faites le choix d'afficher du texte,
                                    vous pouvez modifier sa position en hauteur
                                    et la taille des caractères (curseurs).
                                </p>
                            </li>
                            <li>
                                <p>
                                    Sur une carte, vous pouvez choisir
                                    d'afficher ou non une image. Si vous faites
                                    le choix d'afficher une image, vous pouvez
                                    la choisir sur votre ordinateur en cliquant
                                    sur le bouton [Uploader une image].
                                </p>
                            </li>
                            <li>
                                <p>
                                    Lorsque une carte est prête, valider. La
                                    carte va alors s'ajouter dans l'aperçu en
                                    bas de page. Pour supprimer une carte de
                                    l'aperçu, cliquer sur la croix en bas à
                                    droite.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Pour télécharger les cartes au format pdf,
                                    cliquer sur le bouton [Télécharger].
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default index;
